import { Skeleton, Stack } from "@mui/material";

// Shared skeleton for the Brands screen — used both for the initial page
// load (BrandsTabs.tsx, before allBrandsData has been fetched) and as a
// per-tab fallback (e.g. AllBrands.tsx) if a tab ever refetches on its own.
const BrandsSkeleton = () => (
  <Stack spacing={2} sx={{ mt: 2 }}>
    <Stack direction="row" spacing={2}>
      <Skeleton variant="rounded" width={100} height={32} />
      <Skeleton variant="rounded" width={180} height={32} />
      <Skeleton variant="rounded" width={150} height={32} />
    </Stack>
    <Stack direction="row" spacing={2}>
      <Skeleton variant="rounded" width={240} height={40} />
      <Skeleton variant="rounded" width={120} height={40} />
      <Skeleton variant="rounded" width={160} height={40} />
      <Skeleton variant="rounded" width={140} height={40} />
      <Skeleton variant="rounded" width={140} height={40} />
    </Stack>
    <Skeleton variant="text" width={280} height={24} />
    <Skeleton variant="rounded" height={40} />
    {Array.from({ length: 8 }).map((_, index) => (
      <Skeleton key={index} variant="rounded" height={44} />
    ))}
  </Stack>
);

export default BrandsSkeleton;
